import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Media} from '../../../api/models/media';
import { Camera } from '../../../api/models/camera';

@Component({
  selector: 'app-media-preview',
  templateUrl: './media-preview.component.html',
  styleUrls: ['./media-preview.component.css']
})
export class MediaPreviewComponent implements OnInit {

  @Input() media: Media;
  @Input() cameras: Camera[];
  @Input() selectedCamera: number;
  @Output() mediaSelected = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  getHoure(): string {
    return this.media.name.slice(8, 10) + ':' + this.media.name.slice(10, 12);
  }

  getSource(): string {
    return this.media.folder + '/' + this.media.name + '.jpg';
  }

  get transformStyle(): string {
    const cam = this.cameras.find(camera => camera.id === this.selectedCamera);
    if (cam && cam.orientation === 'Portrait') {
      return 'rotate(90deg)';
    }
    return 'none';
  } 

  

  get imageClass(): string {
    const cam = this.cameras.find(camera => camera.id === this.selectedCamera);
    return cam && cam.orientation === 'Portrait' ? 'portrait-transform' : '';
  }

  onMediaSelection() {
    this.mediaSelected.emit(this.media);
  }
}
